export const tabs2023Gql = /* GraphQL */ `
... on landingPageContent2023_tabs_BlockType {
    typeHandle
    tabTheme
    mobileTabOpenBehavior
    sectionTitle
    tabsV2LandingPage {
        ... on tabsV2LandingPage_BlockType {
            contentBody
            contentTitle
            tabTitle
            contentCta {
                ariaLabel
                customText
                target
                text
                url
            }
            mediaObjectFit
            tabMedia {
                __typename
                ... on images_Asset {
                    title
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                }
                ... on videos_Asset {
                    title
                    videoId
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                    videoThumbnail {
                        ... on images_Asset {
                            title
                            galleryEnlarged {
                                srcWebp
                                srcset
                            }
                        }
                    }
                }
                ... on videoUploads_Asset {
                    url
                    videoThumbnail {
                        ... on images_Asset {
                            title
                            galleryEnlarged {
                                srcWebp
                                srcset
                            }
                        }
                    }
                }
            }
        }
    }
}`;
